import { useState } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { Edit } from "@material-ui/icons";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { ITicketSearchRequest } from 'helpers/interfaces';


interface IProps {
    selectedItems: string[]
    selectAllPages: boolean
    numberOfItems: number
    search: ITicketSearchRequest
}

let BulkEdit = (props: IProps) => {
    let history = useHistory();

    let [isSaving, setSaving] = useState(false);

    let saveBulkEditRequest = async () => {
        try {
            setSaving(true);

            let request = {
                numberOfItems: props.selectAllPages ? props.numberOfItems : props.selectedItems.length,
                selectedIds: props.selectedItems,
                selectAllPages: props.selectAllPages,
                ...props.search
            }

            let res = await axios.post('/api/bulkedit/SaveBulkEditRequest', request);
            history.push(`/bulkEdit/${res.data.id}`);
        } catch (err) {
            setSaving(false);
        }
    }

    return (
        <Button
            variant="outlined"
            color="secondary"
            size="small"
            disabled={isSaving}
            onClick={async () => await saveBulkEditRequest()}
        >
            {isSaving ? <CircularProgress size={16} /> : <Edit />}&nbsp;Bulk Edit
        </Button>
    )
}

export default BulkEdit;